import type { SerializedError } from "../types/job.js";

export class SilentCronXError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SilentCronXError";
  }
}

export class JobTimeoutError extends SilentCronXError {
  constructor(message = "Job timed out") {
    super(message);
    this.name = "JobTimeoutError";
  }
}

export class JobCancelledError extends SilentCronXError {
  constructor(message = "Job cancelled") {
    super(message);
    this.name = "JobCancelledError";
  }
}

export function serializeError(error: unknown): SerializedError {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }
  return {
    name: "Error",
    message: typeof error === "string" ? error : JSON.stringify(error),
  };
}
